import React, { Fragment } from 'react';

const Actions = () => (
  <Fragment />
);

export default Actions;
